import CryptoJS from 'crypto-js';

export default {
    /**
     * 암호화
     * @param data
     * @param time
     * @returns {string}
     */
    encryptFunc(data, time) {
        const refreshToken = localStorage.getItem('refreshToken');

        function encrypt(_data) {
            function toHex(str) {
                let hex = '';
                for (let i = 0; i < str.length; i++) {
                    hex += str.charCodeAt(i).toString(16);
                }
                return hex;
            }

            let key = CryptoJS.SHA256(`${refreshToken}${time}`).toString();

            return toHex(CryptoJS.AES.encrypt(_data, key).toString());
        }

        return encrypt(data);
    }
}